import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'ls-button-atom',
  standalone: true,
  imports: [ButtonModule, RippleModule, CommonModule],
  templateUrl: './button-atom.component.html',
  styleUrl: './button-atom.component.scss',
})
export class ButtonAtomComponent {
  @Input() label!: string;

  @Input() type = 'button';

  @Input() styleClass = '';

  @Input() disabled = false;

  @Input() loading = false;

  @Input() size?: 'small' | 'large';

  @Input() severity?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'help'
    | 'danger';

  // @Input() type!: string;

  @Output() onClick = new EventEmitter<Event>();

  handleClick(event: Event) {
    this.onClick.emit(event);
  }
}
